module.exports = "::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  margin: 0 !important; }\n\n.header-success {\n  background-color: #ff8900 !important;\n  padding: 10px !important;\n  color: #ffffff;\n  font-weight: bold; }\n\n.header-title {\n  margin: 0% !important;\n  margin-left: 5px !important; }\n\n.width-buttons {\n  width: 140px !important; }\n\n.position-buttons {\n  text-align: center !important; }\n\n.label-header {\n  font-size: 12pt !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulo-vista/retirar-saldo-modal/retirar-saldo-modal.component.scss
// module id = ./src/app/modulo-vista/retirar-saldo-modal/retirar-saldo-modal.component.scss
// module chunks = main